import { render } from "./informacoes_gerais_molde.vue?vue&type=template&id=0214bc6e&scoped=true"
import script from "./informacoes_gerais_molde.vue?vue&type=script&lang=js"
export * from "./informacoes_gerais_molde.vue?vue&type=script&lang=js"

import "./informacoes_gerais_molde.vue?vue&type=style&index=0&id=0214bc6e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0214bc6e"]])

export default __exports__